const style = {
  /*======Top Section Start=====*/
  root: {
    color: "#fff",
    width: "100%",
    margin: "0 auto 35px",
    paddingTop: "26px",
    background:
      "top right/60% 500px no-repeat url(/images/home/ellipse.png),#0c091b",

    fontFamily: "'Inter',sans-serif !important",
    "@media(max-width:480px)": {
      paddingTop: "0",
      margin: "0 auto",
    },
    "@media(max-width:992px)": {
      paddingTop: "0",
    },
  },
  bannerContainer: {
    display: "flex",
    flexWrap: "wrap",
    maxWidth: "1280px",
    margin: "auto",
    alignItems: "center",
    padding: "0px 0",
    textAlign: "center",
    "& > a": {
      color: "#fff",
      margin: "12px 0",
      fontWeight: "700",
      fontSize: "16px",
      position: "relative",
      display: "block",
      width: "100%",
      textDecoration: "underline",
    },
    "& .slick-slider": {
      width: "100%",
    },
    "& .slick-slider .slick-prev:before, & .slick-slider button.slick-prev": {
      content: "''",
      width: "26px",
      height: "48px",
      background: "center/contain no-repeat url(/images/home/banner-prev.svg)",
      left: "30px",
      zIndex: "1",
    },
    "& .slick-slider .slick-next:before, & .slick-slider button.slick-next": {
      content: "''",
      width: "26px",
      height: "48px",
      background: "center/contain no-repeat url(/images/home/banner-next.svg)",
      right: "30px",
      zIndex: "1",
    },
    "& .slick-slider .slick-dots li button:before": {
      fontSize: "12px",
      color: "#fff",
      opacity: "1",
    },
    "& .slick-slider .slick-dots li.slick-active button:before": {
      fontSize: "14px",
      color: "#e91e63",
      opacity: "1",
    },
    "@media(max-width:480px)": {
      padding: "20px 0 40px",
      marginBottom: "20px",
    },
  },
  bannerContentBox: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: "1318px",
    margin: "auto",
    background:
      "center / cover no-repeat url(/images/home/bg-texture.png), linear-gradient(180deg, #241764 0%, #0C091B 100%)",
    borderRadius: "30px 30px 0 0",
    "@media(max-width:480px)": {
      padding: "0 15px",
    },
  },
  bannerContent: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "left",
    width: "50%",
    padding: "10px 15px",
    "& p": {
      fontSize: "21px",
      fontWeight: "400",
      color: "#fff",
      marginBottom: "12px",
    },
    "& span": {
      position: "relative",
      display: "block",
      textTransform: "uppercase",
      fontSize: "28px",
      fontWeight: "600",
      color: "#FFD600",
      marginBottom: "36px",
    },
    "& a": {
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: "#fff",
      padding: "0 16px",
      width: "173px",
      height: "48px",
      borderRadius: "12px",
      fontSize: "18px",
      fontWeight: "700",
      color: "#000",
      marginBottom: "36px",
      "@media(max-width:480px)": {
        padding: "0 7px",
        width: "125px",
        height: "34px",
        borderRadius: "7px",
        fontSize: "14px",
        marginBottom: "0",
        "& img": {
          width: "14px",
        },
      },
    },
    "@media (max-width:992px)": {
      width: "85%",
      marginTop: "30px",
    },
    "@media (max-width:767px)": {
      width: "100%",
      margin: "auto",
      "& span": {
        fontSize: "16px",
      },
    },
    "@media (max-width:480px)": {
      width: "100%",
      "& p": {
        fontSize: "10px",
      },
      "& span": {
        fontSize: "12px",
        marginBottom: "12px",
      },
      "& h2": {
        fontSize: "24px",
      },
    },
  },
  bannerTitle: {
    position: "relative",
    display: "block",
    width: "100%",
    marginBottom: "0",
    margin: "auto",
    fontWeight: "800",
    color: "#FFFFFF",
    fontSize: "54px",
    "@media(max-width:767px)": {
      fontSize: "40px",
    },
    "@media(max-width:480px)": {
      fontSize: "28px",
    },
  },
  bannerSubTitle: {
    color: "#0C091B",
    background:
      "linear-gradient(45deg, rgba(225, 64, 132, 1) 0%, rgba(52, 84, 250, 1) 47%, rgba(84, 181, 187, 1) 80%)",
    WebkitBackgroundClip: "text",
    WebkitTextStroke: "3px transparent",
    fontWeight: "700",
    fontSize: "44px",
    position: "relative",
    display: "block",
    width: "100%",
    "@media(max-width:767px)": {
      fontSize: "70px",
    },
    paddingTop: "5px",
    paddingBottom: "0",
    marginBottom: {
      tablet: "0",
      mobile: "0",
    },
    textTransform: "uppercase",
    letterSpacing: "0.02em",
    "@media(max-width:480px)": {
      padding: "5px 15px 0",
      fontSize: "24px",
      WebkitTextStroke: "3px transparent",
      letterSpacing: "0.05em",
    },
  },
  bannerParagraph: {
    marginBottom: "50px",
    fontSize: "20px",
    lineHeight: "22px",
    marginTop: "20px",
    display: "block",
    "@media(max-width:480px)": {
      display: "none",
    },
  },
  bannerImageContainer: {
    width: "50%",
    padding: "30px 0",
    textAlign: "center",
    "@media(max-width:767px)": {
      width: "100%",
      padding: "15px 0",
    },
  },
  bannerImage: {
    width: "100%",
    padding: {
      desktop: "36px",
      laptop: "36px",
      tablet: "60px 0",
    },
    maxWidth: "545px",
  },
  songBannerContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "477px",
    maxWidth: "477px",
    borderRadius: "10px",
    overflow: "hidden",
    margin: "auto",
    marginTop: "24px",
    background:
      "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    "& img:last-child": {
      width: "270px",
      height: "270px",
      // borderRadius:"16px",
      // border:"5px solid #FFFFFF",
      objectFit: "cover",
      position: "relative",
      zIndex: "1",
    },
    "@media(max-width:480px)": {
      height: "300px",
      maxWidth: "300px",
      marginTop: "0",
      "& img:last-child": {
        width: "170px",
        height: "170px",
      },
    },
  },
  bgSongBanner: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "450px",
    margin: "auto",
    borderRadius: "20px",
    "@media(max-width:480px)": {
      borderRadius: "10px",
    },
  },
  animateContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    maxWidth: "590px",
    margin: "60px auto 0",
    "@media(max-width:992px)": {
      height: "395px",
      margin: "30px auto 0",
    },
    "@media(max-width:767px)": {
      transform: "scale(0.8)",
      height: "300px",
      marginBottom: "30px",
    },
    "@media(max-width:480px)": {
      transform: "scale(0.7)",
      margin: "0 auto",
    },
  },
  mainImage: {
    width: "20%",
    position: "relative",
    zIndex: "2",
  },
  circle1: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translateX(-50%) translateY(-50%)",
    borderRadius: "50%",
    border: "1px solid #3a3960",
    width: "205px",
    height: "205px",
  },
  circle2: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translateX(-50%) translateY(-50%)",
    borderRadius: "50%",
    border: "1px solid #3a3960",
    width: "319px",
    height: "319px",
  },
  circle3: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translateX(-50%) translateY(-50%)",
    borderRadius: "50%",
    border: "1px solid #3a3960",
    width: "416px",
    height: "416px",
  },
  pinkDotInner1: {
    position: "absolute",
    transform: "translateX(60px) translateY(-81px)",
    borderRadius: "50%",
    border: "1px solid #3a3960",
    width: "18px",
    height: "18px",
    background: "linear-gradient(#c228ff, #ff2a7d)",
    animation: "innerOrbit1 30s linear infinite",
    "@keyframes innerOrbit1": {
      from: {
        transform:
          "rotate(0deg) translateX(60px) translateY(-81px) rotate(0deg)",
      },
      to: {
        transform:
          "rotate(360deg) translateX(60px) translateY(-81px) rotate(-360deg)",
      },
    },
  },
  person1: {
    position: "absolute",
    transform: "translateX(-95px) translateY(-128px)",
    borderRadius: "50%",
    border: "1px solid #3a3960",
    width: "54px",
    height: "54px",
    animation: "person1 30s linear infinite",
    "@keyframes person1": {
      from: {
        transform:
          "rotate(0deg) translateX(-95px) translateY(-128px) rotate(0deg)",
      },
      to: {
        transform:
          "rotate(360deg) translateX(-95px) translateY(-128px) rotate(-360deg)",
      },
    },
  },
  pinkDotInner2: {
    position: "absolute",
    transform: "translateX(-60px) translateY(81px)",
    borderRadius: "50%",
    border: "1px solid #3a3960",
    width: "18px",
    height: "18px",
    background: "linear-gradient(#c228ff, #ff2a7d)",
    animation: "innerOrbit2 30s linear infinite",
    "@keyframes innerOrbit2": {
      from: {
        transform:
          "rotate(0deg) translateX(-60px) translateY(81px) rotate(0deg)",
      },
      to: {
        transform:
          "rotate(360deg) translateX(-60px) translateY(81px) rotate(-360deg)",
      },
    },
  },
  pinkDotMid: {
    position: "absolute",
    transform: "translateX(20px) translateY(-157px)",
    borderRadius: "50%",
    border: "1px solid #3a3960",
    width: "12px",
    height: "12px",
    background: "linear-gradient(#c228ff, #ff2a7d)",
    animation: "midOrbit 30s linear infinite",
    "@keyframes midOrbit": {
      from: {
        transform:
          "rotate(0deg) translateX(20px) translateY(-157px) rotate(0deg)",
      },
      to: {
        transform:
          "rotate(360deg) translateX(20px) translateY(-157px) rotate(-360deg)",
      },
    },
  },
  person2: {
    position: "absolute",
    transform: "translateX(-148px) translateY(50px)",
    borderRadius: "50%",
    border: "1px solid #3a3960",
    width: "54px",
    height: "54px",
    animation: "person2 30s linear infinite",
    "@keyframes person2": {
      from: {
        transform:
          "rotate(0deg) translateX(-148px) translateY(50px) rotate(0deg)",
      },
      to: {
        transform:
          "rotate(360deg) translateX(-148px) translateY(50px) rotate(-360deg)",
      },
    },
  },
  person3: {
    position: "absolute",
    transform: "translateX(95px) translateY(120px)",
    borderRadius: "50%",
    border: "1px solid #3a3960",
    width: "54px",
    height: "54px",
    animation: "person3 30s linear infinite",
    "@keyframes person3": {
      from: {
        transform:
          "rotate(0deg) translateX(95px) translateY(120px) rotate(0deg)",
      },
      to: {
        transform:
          "rotate(360deg) translateX(95px) translateY(120px) rotate(-360deg)",
      },
    },
  },
  pinkDotOuter: {
    position: "absolute",
    transform: "translateX(-135px) translateY(-160px)",
    borderRadius: "50%",
    border: "1px solid #3a3960",
    width: "27px",
    height: "27px",
    background: "linear-gradient(#c228ff, #ff2a7d)",
    animation: "outerOrbit 30s linear infinite",
    "@keyframes outerOrbit": {
      from: {
        transform:
          "rotate(0deg) translateX(-135px) translateY(-160px) rotate(0deg)",
      },
      to: {
        transform:
          "rotate(360deg) translateX(-135px) translateY(-160px) rotate(-360deg)",
      },
    },
  },
  person4: {
    position: "absolute",
    transform: "translateX(-55px) translateY(195px)",
    borderRadius: "50%",
    border: "1px solid #3a3960",
    width: "54px",
    height: "54px",
    animation: "person4 30s linear infinite",
    "@keyframes person4": {
      from: {
        transform:
          "rotate(0deg) translateX(-55px) translateY(195px) rotate(0deg)",
      },
      to: {
        transform:
          "rotate(360deg) translateX(-55px) translateY(195px) rotate(-360deg)",
      },
    },
  },
  person5: {
    position: "absolute",
    transform: "translateX(86px) translateY(-190px)",
    borderRadius: "50%",
    border: "1px solid #3a3960",
    width: "54px",
    height: "54px",
    animation: "person5 30s linear infinite",
    "@keyframes person5": {
      from: {
        transform:
          "rotate(0deg) translateX(86px) translateY(-190px) rotate(0deg)",
      },
      to: {
        transform:
          "rotate(360deg) translateX(86px) translateY(-190px) rotate(-360deg)",
      },
    },
  },
  joinCommunity: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "998px",
    margin: "74px auto 0",
    padding: "0 15px",
    "& > p": {
      color: "#fff",
      fontSize: "18px",
      fontWeight: "500",
      marginBottom: "13px",
    },
  },

  /*======How It Works Start=====*/
  howItWorksSection: {
    backgroundColor: "#0c091b",
    padding: "0px 25px 120px",
    maxWidth: "1280px",
    margin: "auto",
    fontFamily: "'Inter',sans-serif !important",
    "@media (max-width:480px)": {
      padding: "0px 25px 0",
    },
  },

  returnCalculator: {
    position: "relative",
    textAlign: "center",
    display: "block",
    fontWeight: "600",
    width: "100%",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    marginTop: "20px",
    borderRadius: "10px",
    height: "56px",
    color: "#fff",
    textDecoration: "none",
    cursor: "pointer",
    textTransform: "capitalize",
    "&:hover": {
      color: "#fff",
      textDecoration: "none",
    },
    "@media(max-width:992px)": {
      margin: "auto",
      marginTop: "30px",
    },
  },
  howItWorkspopup: {
    backgroundColor: "#19132A",
    padding: "0px 25px 120px",
    maxWidth: "1280px",
    margin: "auto",
    fontFamily: "'Inter',sans-serif !important",
    "@media (max-width:480px)": {
      padding: "0px 25px 0",
    },
  },
  sectionTitleH1: {
    textAlign: "center",
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    lineHeight: "51px",
    marginBottom: "48px",
    "@media (max-width:480px)": {
      fontSize: "24px",
      fontWeight: "600",
      marginBottom: "20px",
    },
  },
  howItWorksRow: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    position: "relative",
    alignItems: "center",
    "@media (max-width:480px)": {
      marginBottom: "20px",
    },
  },
  rowContainer: {
    "& > div:nth-child(even)": {
      flexDirection: "row-reverse",
    },
    "& > div:nth-child(even) > div:first-child": {
      justifyContent: "start",
    },
    "& > div:nth-child(even) > div:last-child": {
      textAlign: "right",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "end",
    },
    "& > div:hover > span": {
      borderColor: "#E14084",
    },
    "@media (max-width:480px)": {
      "& > div:nth-child(even)": {
        flexDirection: "unset",
      },
      "& > div:last-child > span": {
        display: "none",
      },
      "& > div:nth-child(even) > div:last-child": {
        justifyContent: "start",
      },
    },
  },
  Vseparate: {
    position: "absolute",
    top: "0",
    bottom: "0",
    left: "50%",
    transform: "translateX(-50%)",
    borderLeft: "1px solid #ccc",
    "@media (max-width:480px)": {
      left: "2px",
      top: "100px",
      height: "calc(100% + 30px)",
    },
  },
  howItWorksRowImage: {
    position: "relative",
    display: "block",
    width: "45%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "end",
    alignItems: "center",
    padding: "30px",
    "@media (max-width:767px)": {
      width: "70%",
      textAlign: "center",
    },
    "@media (max-width:480px)": {
      width: "100%",
      padding: "0 0 0 25px",
      justifyContent: "start",
      "& img": {
        width: "73px",
      },
    },
  },
  hiwRowContent: {
    position: "relative",
    display: "block",
    width: "45%",
    padding: "15px 25px",
    background: "#1a1728",
    borderRadius: "10px",
    border: "7px solid rgba(255, 255, 255, 0.03)",
    transition: "0.3s",
    "& *": {
      display: "block",
    },
    "&:hover p:first-child": {
      background: "#E14084",
      color: "#fff",
      transition: "0.3s",
    },
    "&:hover h1": {
      color: "#E14084",
      transition: "0.3s",
    },
    "@media (max-width:480px)": {
      width: "100%",
      background: "none",
      border: "none",
    },
  },
  countNum: {
    position: "relative",
    display: "block",
    width: "39px",
    height: "39px",
    lineHeight: "39px",
    fontSize: "20px",
    fontWeight: "700",
    color: "#000",
    background: "#fff",
    borderRadius: "50%",
    textAlign: "center",
    marginBottom: "16px",
    "@media (max-width:480px)": {
      position: "absolute",
      width: "24px",
      height: "24px",
      lineHeight: "24px",
      fontSize: "14px",
      left: "-10px",
      top: "25px",
    },
  },
  hiwRowContentTitle: {
    width: "100%",
    lineHeight: "45px",
    fontSize: "24px",
    color: "#fff",
    fontWeight: "700",
    display: "block",
    marginBottom: "12px",
    "@media (max-width:992px)": {
      width: "100%",
      textAlign: "left",
    },
    "@media (max-width:480px)": {
      fontSize: "24px",
      fontWeight: "600",
    },
  },
  songDetailhiwRowContentTitle: {
    width: "100%",
    lineHeight: "45px",
    fontSize: "22px",
    color: "#fff",
    fontWeight: "700",
    display: "block",
    marginBottom: "12px",
    "@media (max-width:992px)": {
      width: "100%",
      textAlign: "left",
    },
    "@media (max-width:480px)": {
      fontSize: "24px",
      fontWeight: "600",
    },
  },
  hiwRowContentDescription: {
    fontSize: "18px",
    fontWeight: "500",
    lineHeight: "30px",
    color: "#fff",
    margin: "0",
    display: "block",
    "@media (max-width:767px)": {
      paddingLeft: "0",
    },
    "@media (max-width:480px)": {
      fontSize: "14px",
      lineHeight: "20.9px",
      textAlign: "left",
    },
  },
  songDetailHiwRowContentDescription: {
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "30px",
    color: "#fff",
    margin: "0",
    display: "block",
    "@media (max-width:767px)": {
      paddingLeft: "0",
    },
    "@media (max-width:480px)": {
      fontSize: "14px",
      lineHeight: "20.9px",
      textAlign: "left",
    },
  },
  glowImage: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    bottom: "-110px",
  },
  hiwContentBox: {
    width: "100%",
  },
  hiwImageSeparator: {
    width: "100%",
    height: "2.7px",
    background: "#fff",
    borderRadius: "7px",
    boxShadow: "0px 0px 20px 1px #ff3780",
    margin: "40px 0 20px 40px",
    "@media (max-width:767px)": {
      margin: "40px 0 20px 0",
    },
    "@media (max-width:480px)": {
      margin: "25px 0 20px 35px",
    },
  },
  /*======Join Community Start=====*/
  communitySection: {
    position: "relative",
    display: "block",
    padding: "0 25px 60px",
    fontFamily: "'Inter',sans-serif !important",
  },
  communityHeading: {
    color: "#fff",
    textAlign: "center",
    marginBottom: "20px",
  },
  communityTitle: {
    fontWeight: "700",
    fontSize: "42px",
    lineHeight: "51px",
    "@media (max-width:480px)": {
      fontSize: "24px",
      fontWeight: "500",
      letterSpacing: "1px",
    },
  },
  communityImgContainer: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    position: "relative",
    maxWidth: "1280px",
    margin: "auto",
    padding: "0 15px",
    justifyContent: "center",
  },
  communityBox: {
    position: "relative",
    display: "block",
    width: "100%",
    minWidth: "260px",
    maxWidth: "33.33%",
    padding: "0 15px",
    "@media (max-width:767px)": {
      "&:nth-of-type(1), :nth-of-type(2)": {
        display: "none",
      },
    },
  },
  communityBoxImg: {
    width: "100%",
    borderRadius: "10px",
  },
  communityJoinSection: {
    position: "relative",
    height: "204px",
    width: "100%",
    textAlign: "center",
    color: "#fff",
    borderRadius: "10px",
    background:
      "center / 80% no-repeat url(/images/home/join-community.png),rgba(0, 0, 0, 0.9)",

    marginTop: "10px",
    padding: "0 15px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    "& p": {
      fontSize: "14px",
      fontWeight: "500",
      width: "154px",
    },
    "& img": {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
      zIndex: "1",
      mixBlendMode: "screen",
      width: "570px",
      maxWidth: "initial",
      "@media(max-width:480px)": {
        width: "calc(100% + 125px)",
      },
    },
    "@media(max-width:480px)": {
      background:
        "center / 90% no-repeat url(/images/home/join-community.png),rgba(0, 0, 0, 0.9)",
    },
  },

  /*======Join Community Start=====*/
  communitySection: {
    position: "relative",
    display: "block",
    padding: "0 25px 60px",
    fontFamily: "'Inter',sans-serif !important",
  },
  communityHeading: {
    color: "#fff",
    textAlign: "center",
    marginBottom: "20px",
  },
  communityTitle: {
    fontWeight: "700",
    fontSize: "42px",
    lineHeight: "51px",
    "@media (max-width:480px)": {
      fontSize: "24px",
      fontWeight: "500",
      letterSpacing: "1px",
    },
  },
  communityImgContainer: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    position: "relative",
    maxWidth: "1280px",
    margin: "auto",
    padding: "0 15px",
    justifyContent: "center",
  },
  communityBox: {
    position: "relative",
    display: "block",
    width: "100%",
    minWidth: "260px",
    maxWidth: "33.33%",
    padding: "0 15px",
    "@media (max-width:767px)": {
      "&:nth-of-type(1), :nth-of-type(2)": {
        display: "none",
      },
    },
  },
  followerBox: {
    position: "relative",
    display: "flex",
    width: "100%",
    alignItems: "end",
    padding: "20px",
    overflow: "hidden",
    borderBottom: "1px solid #ccc",
    background: "#fff",
    borderRadius: "10px 10px 0 0",
    "& div:nth-child(2)": {
      width: "100%",
    },
    "& > div > img": {
      minWidth: "42px",
    },
    "& h5": {
      fontSize: "16px",
      fontWeight: "700",
      marginBottom: "12px",
    },
    "& p": {
      fontSize: "12px",
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.54)",
    },
    "& a": {
      fontSize: "12px",
      fontWeight: "400",
      color: "#e14084",
      whiteSpace: "nowrap",
    },
  },
  lockedUser: {
    position: "relative",
    display: "block",
    width: "42px !important",
    marginRight: "16px",
    "& span": {
      position: "absolute",
      bottom: "0",
      right: "0",
      width: "20px",
      height: "20px",
      background: "#E14084",
      borderRadius: "50%",
      textAlign: "center",
      lineHeight: "15px",
    },
  },
  communityBoxImg: {
    width: "100%",
    borderRadius: "0 0 10px 10px",
  },
  communityJoinSection: {
    position: "relative",
    height: "204px",
    width: "100%",
    textAlign: "center",
    color: "#fff",
    borderRadius: "10px",
    background:
      "center / 80% no-repeat url(/images/home/join-community.png),rgba(0, 0, 0, 0.9)",
    marginTop: "10px",
    padding: "0 15px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    "& p": {
      fontSize: "14px",
      fontWeight: "500",
      width: "154px",
    },
    "& img": {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
      zIndex: "1",
      mixBlendMode: "screen",
      width: "570px",
      maxWidth: "initial",
    },
  },

  socialPContainer: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    justifyContent: "space-between",
    maxWidth: "470px",
    "@media(max-width:480px)": {
      justifyContent: "space-around",
    },
  },
  communitySocial: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    borderRadius: "8px",
    background: "#fff",
    minHeight: "67px",
    padding: "16px 24px",
    "& span": {
      color: "#000",
      fontSize: "16px",
      fontWeight: "500",
      width: "100%",
      maxWidth: "450px",
    },
    "@media(max-width:992px)": {
      justifyContent: "center",
      "& span": {
        marginBottom: "12px",
      },
    },
  },
  socialPlatform: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    color: "#000",
    textAlign: "center",
    padding: "0 10px",
    "& p": {
      fontSize: "16px",
      fontWeight: "500",
      marginLeft: "8px",
    },
    "@media(max-width:767px)": {
      padding: "0",
    },
    "@media(max-width:480px)": {
      justifyContent: "center",
      maxWidth: "120px",
    },
    "& a": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "wrap",
      color: "#000",
    },
  },
  homePopupContainer: {
    overflow: "visible",
    "@media(max-width:480px)": {
      transform: "scale(0.8) !important",
      left: "-15px",
    },
  },
  modalHome: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dataContainer: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "582px",
    margin: "auto",
    color: "#fff",
  },
  communityChHeading: {
    fontSize: "50px",
    fontWeight: "600",
    letterSpacing: "3px",
    "@media(max-width:480px)": {
      fontSize: "35px",
    },
  },
  communityExplore: {
    position: "relative",
    display: "block",
    textAlign: "center",
    marginTop: "30px",
  },
  CommunityBtnExplore: {
    background: "#fff",
    color: "#0C091B",
    borderRadius: "16px",
    padding: "15px 0",
    border: "1px solid #fff",
    outline: "none",
    marginBottom: "20px",
    fontWeight: "600",
    fontSize: "16px",
    width: "200px",
    textTransform: "capitalize",
    "&:hover": {
      background: "#fff !important",
      color: "#0C091B !important",
    },
  },
  /*======Featured Songs Start=====*/
  featuredSongsSection: {
    backgroundColor: "#0c091b",
    padding: "0 25px 60px",
    maxWidth: "1280px",
    margin: "auto",
    fontFamily: "'Inter',sans-serif !important",
  },
  featuredTitleH1: {
    textAlign: "center",
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    lineHeight: "51px",
    marginBottom: "40px",
    "@media(max-width:767px)": {
      margin: "0px",
      fontSize: "32px",
      letterSpacing: "1px",
      fontWeight: "600",
    },
  },
  featuredSongsBox: {
    display: "flex",
    justifyContent: "left",
    flexWrap: "wrap",
    width: "100%",
    maxWidth: "1280px",
    "@media (max-width:767px)": {
      width: "100%",
      maxWidth: "356px",
    },
  },
  featuredRow: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    marginTop: "20px",
  },
  featuredBox: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    width: "33.33%",
    padding: "15px",
    "@media (max-width:767px)": {
      width: "100%",
      padding: "0px",
    },
  },
  featuredCard: {
    position: "relative",
    display: "block",
    width: "100%",
    borderRadius: "10px",
    overflow: "hidden",
    background: "#19132A",
    marginBottom: "30px",
  },
  featuredCardImageBox: {
    position: "relative",
    display: "block",
    width: "100%",
    marginBottom: "15px",
    borderRadius: "10px",
    overflow: "hidden",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    padding: "4px",
    lineHeight: "0",
  },
  featuredCardImage: {
    width: "100%",
    borderRadius: "10px",
    height: "371px",
    objectFit: "fill",
    cursor: "pointer",
    "@media (max-width:992px)": {
      height: "312px",
    },
    "@media (max-width:767px)": {
      height: "312px",
    },
    "@media (max-width:480px)": {
      height: "312px",
    },
  },
  featuredPlayIcon: {
    position: "absolute",
    left: "30px",
    bottom: "30px",
    width: "30px",
    height: "30px",
    filter: "drop-shadow(2px 2px 3px rgba(0,0,0,0.5))",
  },
  featuredCardContent: {
    position: "relative",
    display: "block",
    padding: "0 15px 15px",
  },
  featuredCardTitle: {
    fontWeight: "400",
    fontSize: "24px",
    color: "#fff",
    "@media (max-width:767px)": {
      fontSize: "20px",
    },
    "@media (max-width:480px)": {
      fontSize: "18px",
    },
  },
  featuredCardSubTitle: {
    fontWeight: "100",
    fontSize: "14px",
    color: "#fff",
  },
  featuredStats: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  featuredTokens: {
    textAlign: "right",
  },
  featuredBuyNow1: {
    position: "relative",
    textAlign: "center",
    display: "block",
    fontWeight: "600",
    width: "100%",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    marginTop: "20px",
    borderRadius: "10px",
    height: "56px",
    color: "#fff",
    textDecoration: "none",
    cursor: "pointer",
    textTransform: "capitalize",
    "&:hover": {
      color: "#fff",
      textDecoration: "none",
    },
    "@media(max-width:992px)": {
      margin: "auto",
      marginTop: "30px",
    },
  },
  featuredBuyNow: {
    position: "relative",
    textAlign: "center",
    display: "block",
    fontWeight: "600",
    width: "100%",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    marginTop: "20px",
    borderRadius: "10px",
    height: "56px",
    color: "#fff",
    paddingTop: "15px",
    textDecoration: "none",
    cursor: "pointer",
    textTransform: "capitalize",
    "&:hover": {
      color: "#fff",
      textDecoration: "none",
    },
    "@media(max-width:992px)": {
      margin: "auto",
      marginTop: "30px",
    },
  },
  featuredBuyOnMarketPlace: {
    position: "relative",
    textAlign: "center",
    display: "block",
    fontWeight: "600",
    width: "100%",
    border: "1px solid #fff",
    marginTop: "20px",
    borderRadius: "10px",
    paddingTop: "15px",
    height: "56px",
    color: "#fff",
    textTransform: "capitalize",
  },
  featuredBtnDisabled: {
    position: "relative",
    textAlign: "center",
    display: "block",
    fontWeight: "600",
    width: "100%",
    background: "#bababa !important",
    marginTop: "20px",
    borderRadius: "10px",
    height: "56px",
    color: "#9C9C9C",
    textTransform: "capitalize",
  },
  featuredBottomText: {
    textAlign: "center",
    position: "relative",
    width: "100%",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    marginTop: "20px",
  },
  spotifyLogo: {
    width: "60px",
    marginLeft: "5px",
  },
  featuredBoxSingle: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    maxWidth: "1280px",
    alignItems: "start",
    justifyContent: "center",
  },
  featuredCardImageBoxSingle: {
    width: "100%",
    maxWidth: "615px",
    borderRadius: "30px",
    overflow: "hidden",
    "& img": {
      width: "100%",
    },
  },
  featuredCardContentSingle: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "450px",
    "@media (max-width:930px)": {
      marginTop: "20px",
    },
  },
  featuredSingleTitle: {
    position: "relative",
    display: "flex",
  },
  songNameContent: {
    "@media (max-width:930px)": {
      marginLeft: "-40px",
    },
  },
  songDate: {
    transform: "rotateZ(-90deg) translateX(-58px) translateY(-2px)",
    color: "#E14084",
    fontWeight: "700",
    display: "block",
    padding: "5px 0",
    borderBottom: "1px solid rgba(255, 255, 255, 0.5)",
    height: "30px",
    fontSize: "16px",
    textTransform: "uppercase",
    whiteSpace: "nowrap",

    "@media (max-width:930px)": {
      transform: "rotateZ(-90deg) translateX(-43px) translateY(-31px)",
    },
    "@media (max-width:767px)": {
      fontSize: "10px",
      fontWeight: "600",
      transform: "rotateZ(-90deg) translateX(-27px) translateY(-33px)",
      height: "25px",
    },
  },
  songName: {
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
      color: "#fff",
    },
    "@media (max-width:480px)": {
      fontSize: "28px",
    },
  },
  singerName: {
    display: "flex",
    color: "#fff",
    alignItems: "center",
    marginTop: "15px",
    "& img": {
      width: "39px",
      height: "39px",
      objectFit: "cover",
      borderRadius: "50%",
      border: "1px solid #FFF",
    },
    "& small": {
      padding: "0 5px",
      fontSize: "24px",
      fontWeight: "600",
    },
    "@media (max-width:480px)": {
      marginTop: "0",
      "& img": {
        width: "24px",
        height: "24px",
      },
      "& small": {
        fontSize: "16px",
      },
    },
  },
  songDescription: {
    color: "#fff",
    fontSize: "14px",
    textAlign: "justify",
  },
  songDetails: {
    paddingLeft: "45px",
    marginTop: "30px",
    "& span": {
      color: "#fff",
      fontSize: "16px",
      fontWeight: "500",
      marginTop: "20px",
      display: "block",
    },
    "@media (max-width:930px)": {
      paddingLeft: "0",
    },
  },
  countDown: {
    fontSize: "45px",
    color: "#fff",
    fontWeight: "600",
    "& span": {
      fontSize: "45px",
    },
  },
  tableCount: {
    marginLeft: "-18px",
    width: "100%",
    maxWidth: "400px",
    "& td": {
      padding: "16px 16px 16px 0",
      borderBottom: "none",
      width: "50px",
    },
    "& td h3": {
      fontWeight: "500",
    },
    "@media (max-width:930px)": {
      marginLeft: "0",
    },
  },
  counterLine: {
    position: "relative",
    display: "block",
    width: "60px",
    borderRadius: "10px",
    height: "7px",
    background: "#E14084",
  },
  buttonSet: {
    display: "flex",
    justifyContent: "space-between",
    "& button": {
      margin: "35px 1px 0",
      // width:"auto",
      padding: "0 20px",
    },
    "& button:nth-of-type(2)": {
      width: "250px",
    },
  },

  /*========Partners Section========*/
  partnersSection: {
    backgroundColor: "#0c091b",
    padding: "0 25px 0",
    maxWidth: "1280px",
    margin: "0 auto 120px",
    fontFamily: "'Inter',sans-serif !important",
    "@media (max-width:480px)": {
      padding: "0 10px 0",
      margin: "0 auto 40px",
    },
  },
  partnersTitleH1: {
    textAlign: "center",
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    lineHeight: "51px",
    marginBottom: "48px",
    "@media (max-width:480px)": {
      fontSize: "24px",
      fontWeight: "600",
      marginBottom: "20px",
    },
  },
  partnersRow: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  partnersTabs: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    maxWidth: "650px",
  },
  btnPartnerTab: {
    position: "relative",
    textAlign: "center",
    display: "block",
    width: "100%",
    margin: "0 10px",
    border: "1px solid #fff",
    marginTop: "20px",
    borderRadius: "10px",
    height: "56px",
    color: "#fff",
    textTransform: "capitalize",
    "&:hover": {
      border: "1px solid #fff",
      background: "#fff",
      color: "#0C091B",
    },
    "@media (max-width:480px)": {
      margin: "0 5px",
      padding: "5px 6px",
    },
  },

  btnPartnerActive: {
    background: "#fff",
    color: "#0C091B",
    "&:hover": {
      background: "#fff",
      border: "1px solid #fff",
    },
  },
  clientList: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "900px",
    padding: "0",
    "& li": {
      width: "100%",
      maxWidth: "164.55px",
      margin: "0 18px 36px",
      padding: "0",
    },
    "@media (max-width:480px)": {
      "& li": {
        maxWidth: "145px",
        margin: "0 10px 20px",
      },
    },
    "& img": {
      width: "100%",
    },
  },

  /*========Follow Us Section========*/
  followUsSection: {
    backgroundColor: "#0c091b",
    padding: "0 25px 60px",
    maxWidth: "1280px",
    margin: "auto",
    fontFamily: "'Inter',sans-serif !important",
    "@media(max-width:480px)": {
      padding: "0 25px",
    },
  },
  followUsTitleH1: {
    textAlign: "center",
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    lineHeight: "51px",
    marginBottom: "48px",
    "@media (max-width:480px)": {
      fontSize: "24px",
      fontWeight: "600",
      marginBottom: "20px",
    },
  },
  followUsIcons: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    "@media(max-width:480px)": {
      display: "grid",
      gridTemplateColumns: "auto auto auto",
      justifyContent: "unset",
    },
    "& > div": {
      flexGrow: "1",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
    },
    "& > div > a": {
      position: "relative",
      display: "block",
      textAlign: "center",
      color: "#fff",
      textDecoration: "none",
    },
    "& > div > a > div": {
      padding: "20px 0",
    },
    "@media (max-width:767px)": {
      "& > div > a": {
        maxWidth: "75px",
      },
      "& > div > a img": {
        width: "100%",
      },
      "& > div": {
        marginBottom: "25px",
      },
    },
  },
  iconName: {
    "@media(max-width:480px)": {
      padding: "10px 0",
    },
  },
  shadowBlur: {
    position: "absolute",
    bottom: "0",
    left: "50%",
    transform: "translateX(-50%)",
    filter: "blur(37px)",
    opacity: "0.2",
  },
  /*===========Join Early Access==========*/
  joinAccessSection: {
    background:
      "center/cover no-repeat url(/images/joinearlyaccess/joinearlyaccess.svg),#19132A",
    padding: "0 25px",
    minHeight: "811px",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    borderRadius: "10px",
    margin: "0 auto 120px",
    fontFamily: "'Inter',sans-serif !important",
    "@media (max-width:480px)": {
      padding: "79px 20px",
      minHeight: "initial",
      marginBottom: "40px",
      background:
        "top center/100% auto no-repeat url(/images/joinearlyaccess/joinearlyaccess-mobile-top.svg),bottom center/100% auto no-repeat url(/images/joinearlyaccess/joinearlyaccess-mobile-bottom.svg),#19132A",
    },
  },
  mainTitle: {
    fontSize: "42px",
    marginBottom: "30px",
    color: "#fff",
    textAlign: "center",
    fontWeight: "700",
    "@media (max-width:480px)": {
      fontSize: "24px",
      padding: "0 10px",
    },
  },
  limitedEdition: {
    fontSize: "20px",
    color: "rgba(0, 0, 0, 0.87)",
    fontWeight: "700",
    paddingTop: "20px",
    "@media(max-width:480px)": {
      fontSize: "16px",
    },
  },
  referIncentive: {
    fontSize: "20px",
    fontWeight: "700",
    paddingTop: "20px",
    color: "#FFF",
    textAlign: "center",
    "@media(max-width:480px)": {
      fontSize: "16px",
    },
  },
  gettext: {
    fontSize: "16px",
    fontWeight: "500",
    marginTop: "20px",
    color: "#FFF",
    // textAlign:'center',
    "@media(max-width:480px)": {
      fontSize: "14px",
      color: "#FFF",
    },
  },
  checkReferal: {
    fontSize: "16px",
    fontWeight: "500",
    marginTop: "40px",
    color: "#E14084",
    textAlign: "center",
    textDecoration: "underline",
    cursor: "pointer",
    "@media(max-width:480px)": {
      fontSize: "14px",
      color: "#E14084",
    },
  },
  tandc: {
    fontSize: "16px",
    fontWeight: "500",
    marginTop: "40px",
    color: "#fff",
    textAlign: "center !important",
    textDecoration: "underline",
    cursor: "pointer",
    "@media(max-width:480px)": {
      fontSize: "14px",
      color: "#E14084 !important",
    },
  },
  limitedEdition1: {
    fontSize: "12px",
    fontWeight: "600",
    marginTop: "15px",
    position: "relative",
    top: "7px",
    width: "100%",
    display: "block",
    margin: "auto",
  },
  fantigerNFT: {
    background:
      "linear-gradient(45deg, rgba(225, 64, 132, 1) 0%, rgba(52, 84, 250, 1) 47%, rgba(84, 181, 187, 1) 80%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
    fontSize: "40px",
    fontWeight: "700",
    margin: "0",
    display: "inline-block",
    position: "relative",
    top: "2px",
  },
  inviters: {
    color: "#fff",
    fontSize: "14px",
    textAlign: "center",
    fontWeight: "400",
    margin: "50px 0 24px",
  },
  inputContainer: {
    position: "relative",
    display: "block",
    margin: "0 auto 40px",
  },
  termCondition: {
    color: "#fff",
    fontSize: "14px",
    textAlign: "center",
    fontWeight: "400",
    marginBottom: "23px",
  },
  modalContainer: {
    position: "relative",
    display: "block",
    maxWidth: "800px",
    margin: "0 15px",
    top: "50%",
    left: "50%",
    transform: "translateY(-50%)translateX(-50%)",
    borderRadius: "10px",
    overflow: "hidden",
    background: "#0C091B",
    "@media(max-width:480px)": {
      overflow: "auto",
      margin: "0 5px !important",
    },
  },
  modalHeader: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "15px",
    "&:after": {
      content: "''",
      position: "absolute",
      left: "0",
      right: "0",
      bottom: "0",
      height: "3px",
      background:
        "linear-gradient(45deg, rgba(225, 64, 132, 1) 0%, rgba(52, 84, 250, 1) 47%, rgba(84, 181, 187, 1) 80%)",
    },
  },
  modalTitle: {
    fontSize: "1.5rem",
    color: "#fff",
    fontWeight: "600",
    "@media(max-width:480px)": {
      fontSize: "1.3rem",
    },
  },
  modalBody: {
    position: "relative",
    display: "block",
    padding: "15px",
    background: "#19132A",
    "@media(max-width:480px)": {
      maxHeight: "300px",
      overflow: "auto",
    },
  },
  modalListContent: {
    padding: "0 20px",
    "& li": {
      marginBottom: "15px",
      padding: "0 0 0 10px",
      listStyleType: "decimal",
      display: "list-item",
      "&::marker": {
        color: "#fff",
      },
    },
    "& li p": {
      color: "#fff",
      margin: "0",
      fontSize: "14px",
    },
  },
  /*===========In The News==========*/
  newsImage: {
    width: "100%",
    objectFit: "contain",
    maxHeight: "117px",
  },
  newsLogoList: {
    position: "relative",
    display: "flex",
    overflowX: "auto",
    overflowY: "hidden",
    width: "100%",
    padding: "0",
    justifyContent: "center",
    alignItems: "center",
    "& li": {
      width: "100%",
      padding: "0 8px",
      justifyContent: "center",
    },
    "& img": {
      width: "100%",
    },
  },
  /*===========FAQ==========*/
  FAQSection: {
    position: "relative",
    display: "block",
    width: "100%",
    margin: "auto",
    padding: "30px 0",
    background: "#19132A",
    marginBottom: "120px",
    "@media(max-width:480px)": {
      marginBottom: "40px",
    },
  },
  FAQRow: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    margin: "auto",
    marginTop: "20px",
    width: "100%",
    maxWidth: "1280px",
    padding: "0 15px",
  },
  /*===========Watch Videos==========*/
  watchSection: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    maxWidth: "1310px",
    padding: "0 15px",
    justifyContent: "center",
    margin: "auto",
    marginBottom: "120px",
    "& .slick-slider button.slick-next": {
      width: "62px",
      height: "62px",
      right: "25px",
      top: "50%",
      zIndex: "999",
      background:
        "center / 100% 100% no-repeat url(/images/home/videos/next.png)",
      "&:before": {
        display: "none",
      },
    },
    "& .slick-slider button.slick-prev": {
      width: "62px",
      height: "62px",
      left: "25px",
      top: "50%",
      zIndex: "999",
      background:
        "center / 100% 100% no-repeat url(/images/home/videos/prev.png)",
      "&:before": {
        display: "none",
      },
    },
  },
  watchBox: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    height: "300px",
    padding: "0 7px",
    textAlign: "center",
    "& a": {
      fontSize: "24px",
      color: "#fff",
      fontWeight: "600",
      display: "block",
      marginTop: "24px",
      width: "100%",
      textDecoration: "none",
    },
  },
  firstWatchBox: {
    paddingTop: "60px",
    position: "relative",
    display: "block",
    width: "100%",
    marginBottom: "39px",
    marginRight: "10px",
    "& h1": {
      textAlign: "center",
    },
    "& p": {
      textAlign: "center",
    },
  },
  videoSliderContainer: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "1280px",
  },
  watchTitleH1: {
    fontSize: "42px",
    color: "#fff",
    fontWeight: "700",
  },
  watchSubTitle: {
    fontSize: "24px",
    color: "#fff",
    fontWeight: "600",
    marginTop: "4px",
    textAlign: "left",
  },
  videoBgContainer: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "390px",
    maxHeight: "243px",
    margin: "0 auto",
    borderRadius: "12px",
    overflow: "hidden",
  },
  modalVideo: {
    position: "absolute",
    top: "0",
    left: "0",
    padding: "0 20px",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& iframe": {
      "@media(max-width:767px)": {
        height: "365px",
      },
      "@media(max-width:480px)": {
        height: "270px",
      },
    },
  },
  launchingText: {
    background: "linear-gradient(90.78deg, #B237F6 3.91%, #E94177 96.03%)",
    // position: "absolute",
    width: "303px",
    height: "30px",
    // fontFamily: 'Inter',
    marginBottom: "24px",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "20px",
    lineHeight: "30px",
    backgroundClip: "text",
    color: "#FFF",
    textFillColor: "transparent",
  },
  AppdownloadHeading: {
    fontSize: "42px",
    color: "#fff",
    fontWeight: "700",
    textAlign: "center",
    "@media(max-width:480px)": {
      fontSize: "24px",
      color: "#fff",
      fontWeight: "700",
    },
  },
  AppdownloadDesc: {
    position: "relative",
    fontSize: "22px",
    fontWeight: "600",
    color: "#fff",
    textAlign: "center",
    "& p": {
      margin: "3px",
    },
    "& button": {
      display: "block",
      position: "relative",
      fontWeight: "600",
      left: "37%",
      width: "346px",
      background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
      borderRadius: "12px",
      height: "44px",
      color: "#fff",
      textDecoration: "none",
      textTransform: "capitalize",
      marginBottom: "30px",
      "@media(max-width:480px)": {
        left: "8% !important",
      },
    },
  },
  AppdownloadImage: {
    width: "100%",
  },
};

export default style;
